export const loading = state => {
  return state.loading;
};

export const isLoggedIn = state => {
  return state.isLoggedIn;
};

export const isDark = state =>{
  return state.isDark;
}